import { render, staticRenderFns } from "./huibao.vue?vue&type=template&id=81bc7e86&"
import script from "./huibao.vue?vue&type=script&lang=js&"
export * from "./huibao.vue?vue&type=script&lang=js&"
import style0 from "./huibao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports